<template>
  <div class="animated fadeIn">
    <b-card border-variant="primary">
      <div slot="header">
        <strong>Group(Customer) SignUp</strong>
        <span class="float-right">{{model.last_addr || '-'}}@{{model.created_at | sdate}}</span>
      </div>
      <b-row>
        <b-col md="4">
          <b-form-group label="Allow login" label-for="ph_use"
            v-b-tooltip.hover title="Allow login.">
            <c-switch color="info" label size="sm" v-model="model.is_alive" :disabled="lock" />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group>
            <label for="ph_permisson" v-b-tooltip.hover title="Permission.">Permission</label>
            <v-select v-if="!lock" label="permisson" v-model="model.level" :options="level_list"></v-select>
            <b-form-input type="text" v-if="lock" :value="model.level" plaintext></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group>
            <label for="ph_permisson" v-b-tooltip.hover title="Permission.">Service</label>
            <p>
              <b-badge  :variant="model.service == 'Basic' ? 'info' : 'success'"> {{model.service}} </b-badge>
            </p>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group>
            <label for="ph_company" v-b-tooltip.hover title="Company.">Company</label>
            <b-form-input type="text" id="ph_company" v-model="model.company" :plaintext="lock"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group>
            <label for="ph_nickname">Name</label>
            <b-form-input type="text" id="ph_nickname" v-model="model.nickname" :plaintext="lock"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="4">
          <b-form-group>
            <label for="ph_timezone" v-b-tooltip.hover title="Timezone">Timezone(*)</label>
            <v-select :readonly="true" :disabled="lock" label="name" v-model="region.timezone" :options="codes.timezone" ></v-select>
          </b-form-group>
        </b-col>
        <b-col md="8">
          <b-form-group>
            <label for="ph_address" v-b-tooltip.hover title="Company.">Address</label>
            <b-form-input type="text" id="ph_address" v-model="model.address" :plaintext="lock"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <b-form-group>
            <label for="ph_username" v-b-tooltip.hover title="Login ID">E-mail(ID)</label>
            <b-form-input class="bg-light" type="text" id="ph_username" v-model="model.username" :plaintext="lock"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-button size="sm" variant="success" @click="partner_connect_modal = true"> Accept </b-button>
      <b-button size="sm" variant="danger" @click="confirm = true"> Reject </b-button>
      <b-button size="sm" class="float-right" variant="primary" @click="list"> List </b-button>
    </b-card>
    <b-modal title="User Remove"  class="modal-danger" v-model="confirm" @ok="reject" ok-variant="danger">
      <!-- Are you sure you do not approve the subscriber and want to delete ? -->
      <div class="form-group">
        <label for="reason">Please enter a reason why you did not approve.</label>
        <textarea class="form-control" id="reason" rows="3" v-model="model.reason"></textarea>
        <hr>
        <b-checkbox v-model="model.is_mail">sending you the reason by mail({{model.username}})</b-checkbox>
      </div>
    </b-modal>

    <!-- 파트너 연결 모달 -->
    <b-modal size='xl' title="Connect Partner"  class="modal-primary" v-model="partner_connect_modal" ok-only ok-variant="danger">
      <partner-List :enable_new="false" @select="select_partner" :view_detail="false"></partner-List>
    </b-modal>
    <!-- 파트너 연결 모달 -->
    <b-modal size='ml' title="Sign to partner"  class="modal-primary" v-model="confirm_modal" ok-variant="danger" @ok="accept">
      Would you like to register as your partner?
      <hr>
      Parter : {{model.partner ? model.partner.username : '-'}}
      <hr>
      Group(Customer) : {{model.username}}
    </b-modal>
  </div>
</template>

<script>
import { Api, auth } from '@/service';
import codes from '@/codes';
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import partnerList from '@/views/Management/partner/Partner.List'

export default {
  components: {
    partnerList,
    cSwitch,
    vSelect
  },
  data : () => ({
    codes,
    confirm: false,
    add: false,
    lock: true,
    model : { is_use: true, is_active: true, level: 'user', reason : "" },
    old_username : '',
    allowed: false,
    region : {
      language : codes.language_default,
      country : codes.country_default,
      timezone : codes.timezone_default
    },
    confirm_modal : false,
    partner_connect_modal : false,
    partner_id : 0
  }),
  computed: {
    profile() { return auth.profile; }
  },
  methods: {
    list() { this.$router.push({ name: 'signup' }); this.$emit('refresh'); },
    async get({ id, tag } = this.$route.params) {
      console.log('signup.detail.vue', 'load item', id);
      if(id === 'add') { this.add = true; this.lock = false; return; }
      try{
        this.add = false;
        this.lock = (tag != 'edit');
        let rs = await Api.Manager_Call('user.signup', 'detail', { id : id })
        if(!rs.error) {
          this.model = Object.assign({ group: {} }, this.model, rs.body)
          let is_done_timezone = false;
          codes.timezone.forEach(r => { if(is_done_timezone) { return; } else if(this.model.timezone && r.value == this.model.timezone) { this.region.timezone = r; is_done_timezone = true } });
        } else {
          this.$toastr.e("signup user", 'load failed');
          this.list(); this.$emit('refresh');
        }
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    },
    select_partner(item) {
      this.model = Object.assign({}, this.model, { partner_id : item.id, partner : { username : item.username } })
      this.confirm_modal = true
    },
    async accept(){
      try{
        if(!this.model.partner_id || !this.model.partner || !this.model.partner.username) { return this.$toastr.e('connect partner first') }

        let rs = await Api.Manager_Call('user.signup','update.accept', this.model)
        if(rs.error) { console.error(rs.error, rs.reason); return this.$toastr.e('Approved failed')  }
        this.$toastr.s('Approved.'); this.list();
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText)}
    },
    async reject(){
      try{
        let rs = await Api.Manager_Call('user.signup','update.reject', this.model)
        if(rs.error) { console.error(rs.error, rs.reason); return this.$toastr.e('reject failed')  }
        this.$toastr.s('rejected.', "done"); this.list();
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText)}
    },
    async remove() {
      try {
        let rs = await Api.Manager_Call('user.signup', 'remove', {id : this.model.id });
        if(!rs.error) {
          this.$toastr.s('removed.', this.$route.name);
        } else {
          this.$toastr.e('delete', "failed");
        }
        this.list(); this.$emit('refresh');
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); }
    },
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  created() { console.log('User_Detail.vue', 'created'); },
  destroyed() { console.log('User_Detail.vue', 'destroyed'); },
  mounted() {
    console.log('User_Detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}
</script>
